/* eslint-disable require-jsdoc */
import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Homepage from '../pages/Homepage'
import Primary from '../pages/Primary'
import ScrolltoTop from './ScroltoTop'

class ReactRouter extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Router>
          <ScrolltoTop>
            <Switch>
              <Route exact path='/' component={Primary} />
              <Route exact path='/shop' component={Homepage} />
            </Switch>
          </ScrolltoTop>
        </Router>
      </React.Fragment>
    )
  }
}

export default ReactRouter
